module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-ExtraLight-1655953397f9dedcc6000c04c721aad4.woff2";